module.exports = __webpack_public_path__ + "static/8-92fd93ed5126e58829d7dda184852ab5.jpeg";